import React from "react";
import html2pdf from "html2pdf.js";

function BillingReceipt(props) {
  const [htmlString, setHtmlContent] = React.useState("");
  const newImageUrl =
    "https://qa.dotworksoftware.com/static/media/logo.2e86d8aa.png";

  React.useEffect(() => {
    // Simulate receiving HTML from the backend
    const htmlFromBackend = props.receipthtml;

    // Replace the image source in the HTML string
    const updatedHtml = htmlFromBackend.replaceAll(
      /src="[^"]*"/g,
      `src="${newImageUrl}"`
    );

    // Set the updated HTML content
    setHtmlContent(updatedHtml);
  }, [newImageUrl]);

  // const htmlString = props.receipthtml;
  // console.log("htmlString", htmlString);
  // htmlString.replace(
  //   <img src="https://www.tellagent.com/logo.png" class="logoImg" />,
  //   <img
  //     src="https://qa.dotworksoftware.com/static/media/logo.2e86d8aa.png"
  //     class="logoImg"
  //   />
  // );
  // console.log("htmlString", htmlString);
  const generatePDF = () => {
    const element = document.getElementById("pdf-content"); // Replace 'pdf-content' with the ID of the HTML container you want to convert to PDF

    const opt = {
      margin: 0,
      filename: "converted.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };

    html2pdf()
      .from(element)
      .set(opt)
      .save("Receipt.pdf");
  };
  return (
    <>
      <div>
        <div
          id="pdf-content"
          dangerouslySetInnerHTML={{ __html: htmlString }}
        />
        <button
          variant="primary"
          className="btn-blue btn-head mr-2 menu-btn btn btn-primary form-group"
          style={{ background: "green", marginLeft: 30 }}
          onClick={generatePDF}
        >
          Download PDF
        </button>
      </div>
    </>
  );
}

export default BillingReceipt;
